// extracted by mini-css-extract-plugin
export var container = "LatestCostumerReview-module--container--34eb7";
export var review = "LatestCostumerReview-module--review--6a0ce";
export var reviewContainer = "LatestCostumerReview-module--review-container--8c480";
export var video = "LatestCostumerReview-module--video--bb782";